import { NgModule } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { AppModule as FuncionalidadeModule } from '../../projects/formulario-de-cadastro/src/index'
import { AppRoutingModule } from './app-routing.module'
import { ToastrModule } from 'ngx-toastr'
import { AppComponent } from './app.component'
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'
import { HttpConfigInterceptor } from './HttpConfigInterceptor'
import { T } from 'src/support/t'


@NgModule({
  declarations: [
    AppComponent,
    T
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FuncionalidadeModule,
    HttpClientModule,
    AppRoutingModule,
    ToastrModule.forRoot()
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { 

  
}
